
import { Component, Vue } from 'vue-property-decorator';
import { ApiError } from '@/model/ApiError';
import { Field } from '@/model/table/Field';
import Pageable from '@/model/Pageable';
import { mapActions, mapGetters } from 'vuex';
import { EventResponse } from '@/model/Event';
import { User } from '@/model/Profile';
import EventIcon from '@/components/event/EventIcon.vue';
import PAGE_SIZE from '@/lib/pagination';

@Component({
    components: {
        EventIcon,
    },
    methods: {
        ...mapActions({
            fetchEvents: 'adminStorage/fetchEvents',
        }),
    },

    computed: {
        ...mapGetters({
            events: 'adminStorage/getEvents',
        }),
    },
})
export default class AdminEventTable extends Vue {
    events!: Pageable<EventResponse>;

    onClickError!: ApiError | null;

    fetchEvents!: (page: number) => Promise<void>;

    readonly pageSize = PAGE_SIZE;

    loading = true;

    get getTableFields(): Field[] {
        return [
            {
                key: 'name',
                label: this.$i18n.t('admin.event-table.name').toString(),
            },
            {
                key: 'type',
                label: this.$i18n.t('admin.event-table.type').toString(),
            },
            {
                key: 'projectName',
                label: this.$i18n
                    .t('admin.event-table.project-name')
                    .toString(),
            },
            {
                key: 'fullName',
                label: this.$i18n.t('admin.event-table.full-name').toString(),
            },
            {
                key: 'createdBy.email',
                label: this.$i18n.t('admin.event-table.email').toString(),
            },
            {
                key: 'startDate',
                label: this.$i18n.t('admin.event-table.start-date').toString(),
            },
            {
                key: 'createdAt',
                label: this.$i18n.t('admin.event-table.created-at').toString(),
            },
            {
                key: 'deletedAt',
                label: this.$i18n.t('admin.event-table.deleted-at').toString(),
            },
        ];
    }

    getCreatedByFullName(createdBy: User): string {
        return `${createdBy.firstName} ${createdBy.lastName}`;
    }

    beforeMount(): void {
        this.$store.commit('adminStorage/setError', null);
        this.fetchEvents(0).finally(() => {
            this.loading = false;
        });
    }
}
